import { CONTEST_COURSE_TYPE_OPTIONS } from '../data/contestCourseTypeOptions';
import {
  IContestCourseTypeObject,
  IContestCourseTypeValues,
} from 'types/IContestCourseTypeOptions';

export default function parseContestCourseTypeOptions(
  contestCourseType: IContestCourseTypeValues,
  courseTypeValue: IContestCourseTypeValues
): IContestCourseTypeObject | null {
  const value = courseTypeValue ? courseTypeValue : contestCourseType;
  const courseType = CONTEST_COURSE_TYPE_OPTIONS?.find(
    (obj) => obj.value === value
  );

  if (courseType) {
    return courseType;
  } else {
    return null;
  }
}
